import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddPromptState, addPromptFeatureKey } from './add-prompt.reducer';

const getAddPromptFeature = createFeatureSelector<AddPromptState>(addPromptFeatureKey);

export const getAddPromptCallState = createSelector(getAddPromptFeature, (state) => {
   return state.callState;
});

export const getRecordingPromptCallStatus = createSelector(getAddPromptFeature, (state) => {
   return state.recordingPromptCallStatus;
});

export const getRecordingPromptCallServerIp = createSelector(getAddPromptFeature, (state) => {
   return state.recordingPromptCallServerIp;
});

export const getRecordingPromptCallSessionId = createSelector(getAddPromptFeature, (state) => {
   return state.promptRecordingCallSessionId;
});

export const getRecordingPromptChannelId = createSelector(getAddPromptFeature, (state) => {
   return state.recordingPromptCallChannelId;
});

export const getRecordingPromptCallDetailId = createSelector(getAddPromptFeature, (state) => {
   return state.recordingPromptCallDetailId;
});

export const getIsRecordingFromExtensionState = createSelector(getAddPromptFeature, (state) => {
   return state.recordingNewFromExtension;
});

export const getIsRecordingFileOnlyState = createSelector(getAddPromptFeature, (state) => {
   return state.recordingFileForUpdatePrompt;
});

export const getIsRecordingNewFromAdd = createSelector(getAddPromptFeature, (state) => {
   return state.recordingNewFromAdd;
});

export const getVoicemailGreetingPromptState = createSelector(getAddPromptFeature, (state) => {
   return state.voiceMailGreetingPrompt;
});

export const getRecordedFileState = createSelector(getAddPromptFeature, (state) => {
   return state.recordedFile;
});

export const getIsContinuousAdd = createSelector(getAddPromptFeature, (state) => {
   return state.isContinuous;
});
